import React, { Component } from 'react'
import { NewButton } from '../shared/NewButton'
import { Image } from '../Products/image'
import '../stylesheets/reservations/index.sass'
import noReservations from '../images/noReservations.png'

export default class NoReservations extends Component {

    render() {
      return (
        <div className={'welcome-wrapper row'}>
          <div className={'column one'}>
            &nbsp;
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} className={'column two reservation-welcome'}>
            <Image
              image_url={ noReservations }
              imageClass='product-update-image'
              height='215'
              width='215'
            />
            <div style={{ marginTop: 30, fontSize: 18, fontWeight: 400, color: '#A0A0A0' }} className={'row'}>
              No reservations yet
            </div>
            <div style={{ color: '#4D4D4D' }} className={'row'}>
              When a customer makes a keg reservation it will show up here, or you can add a new reservation yourself.  
            </div>
            <div style={{ color: '#4D4D4D' }} className={'row'}>
              Add your reservation link to your website to allow customers to create reservations. You can find it in “Settings”.
              Click on the new button to add a reservation.
            </div>
          </div>
          <div className={'column three'}>
            &nbsp;
          </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Reservations/noReservations.jsx